import { ActionType, ActionTypes, State } from './types';

const initialState = {
  items: [],
};

const routerReducers = (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case ActionTypes.SAVE_ITEMS:
      return {
        ...state,
        items: action.payload,
      };
    case ActionTypes.CLEAR_ROUTER:
      return initialState;
    default:
      return state;
  }
};

export default routerReducers;
